import React from 'react';
import { Input } from 'antd';

import { Label } from 'components';

const { TextArea } = Input;

const TextAreaField = ({ label, asterisk, rows, containerClassName, ...rest }) => {
  return (
    <div className={containerClassName || ''}>
      <Label label={label} asterisk={asterisk}/>
      <TextArea {...rest} rows={rows || 6} />
    </div>
  );
};

export default TextAreaField;
